<script setup lang="ts">
import { inject } from "vue";
import { useDialogs, dialogInjectionKey } from "../../../composables/useDialogs";

const dialogState = inject( dialogInjectionKey );

const { isOpen, reset } = useDialogs();
</script>

<template>
  <component
    :is="dialogState.component"
    v-if="dialogState"
    v-bind="dialogState.props"
    v-model="isOpen"
    @after-leave="reset" />
</template>
